import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ClienteService } from '../../../../services/cliente/cliente.service';
import { Router } from '@angular/router';
import { TipoDocumento } from '../../../../models/tipo/tipo-documento.class';
import { FiltroBuscarCliente } from '../../../../models/filtro/filtro-buscar-cliente';
import { MatButton, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RedireccionMenu } from '../../../../models/menu/redireccion-menu.class';
import { RedireccionService } from '../../../../services/redireccion/redireccion.service';
import { AsesoriaYVentaClienteDialogComponent } from '../asesoria-y-venta-cliente-dialog/asesoria-y-venta-cliente-dialog.component';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { FiltroCliente } from '../../../../models/filtro/filtro-cliente';
import { AgenteService } from '../../../../services/agente/agente.service';
import { RegulacionService } from '../../../../services/regulacion/regulacion.service';
import { Riesgo } from '../../../../models/cliente/riesgo.class';
import { validateConfig } from '@angular/router/src/config';
import { ValidarCiudadDirective } from '../../../../directives/validar-ciudad.directive';
import * as msg from '../../../../../assets/msg/message.json';
import { MenuItem } from '../../../../models/menu/menu-item.class';
import { RegulacionConstant } from '../../../../contants/regulacion.constant';
import { MensajeInformativoDialogComponent } from '../../../shared/dialogs/mensaje-informativo-dialog/mensaje-informativo-dialog.component';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-consulta-cliente-dialog',
  templateUrl: './consulta-cliente-dialog.component.html',
})
export class ConsultaClienteDialogComponent implements OnInit {
  @ViewChild('btnAceptar')
  btnAceptar: MatButton;

  listTipoDocumentos: TipoDocumento[] = [];
  tipodocumentoSeleccionado: TipoDocumento = null;
  documento: String = '';

  documentoForm = new FormGroup({
    tipoControl: new FormControl(null, [Validators.required]),
    documentControl: new FormControl('', [Validators.required]),
  });

  constructor(
    public dialogRef: MatDialogRef<ConsultaClienteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public menuItem: MenuItem,
    private clienteService: ClienteService,
    private route: Router,
    private redireccionService: RedireccionService,
    private dialogService: DialogService,
    private agenteService: AgenteService,
    private regulacionService: RegulacionService
  ) {}

  ngOnInit() {
    this.clienteService.limpiarFiltros();
    this.cargarListaDocumentos();
  }

  async cargarListaDocumentos() {
    this.listTipoDocumentos = await this.clienteService.getListTipoDocumento(
      this.redireccionService.obtenerCodigoPaisPorTipoRedireccion(),
      this.redireccionService.obtenerCodigoGrupoPersonaPorTipoRedireccion()
    );
    this.listTipoDocumentos = this.clienteService.getTiposDocumentosXCliente(
      this.menuItem.detalleOpcion.documento,
      this.listTipoDocumentos
    );
  }

  formularioValido() {
    return this.documentoForm.status === 'VALID' ? true : false;
  }

  buscarPersona() {
    if (this.formularioValido()) {
      // Obtener dni, ramo, subramo, operación, suboperación
      const riesgos: Riesgo[] = [];
      const riesgo = new Riesgo();
      riesgo.codigoFigura = RegulacionConstant.FIGURA_TOMADOR;
      riesgo.codigoOperacion = this.menuItem.detalleOpcion.operacion;
      riesgo.codigoRamo = this.menuItem.detalleOpcion.ramo;
      riesgo.codigoSubramo = this.menuItem.detalleOpcion.subRamo;
      riesgo.codigoTipoCausal = RegulacionConstant.MORAL;
      riesgo.codigoTipoRiesgo = RegulacionConstant.RIESGO_TIPO_DNI;
      riesgo.riesgo = '' + this.tipodocumentoSeleccionado.id + this.documento;
      riesgos.push(riesgo);

      const validarRiesgoConsultable =
        this.regulacionService.validarRiesgoConsultable(riesgos);
      validarRiesgoConsultable.then(
        (result) => {
          // El servicio de riesgos consultables pudo responder
          if (
            result !== null &&
            Array.isArray(result) &&
            result[0].esRiesgo !== undefined
          ) {
            if (result[0].esRiesgo) {
              // Es riesgo consultable
              this.dialogService.open(MensajeInformativoDialogComponent, {
                mensaje: (<any>msg).msgRegulacion.riesgoMoralMensaje,
              });
            } else {
              // No es riesgo consultable
              this.redireccionarOpcion();
            }
          } else {
            // Error en el servicio de Riesgos Consultables
            this.redireccionarOpcion();
            /*this.dialogService.open(MensajeInformativoDialogComponent, {
            mensaje: (<any>msg).msgRegulacion.errorConsultaRiesgoConsultable
          });*/
          }
        },
        (error) => {
          // Error en el servicio de Riesgos Consultables
          this.redireccionarOpcion();
          /*this.dialogService.open(MensajeInformativoDialogComponent, {
          mensaje: (<any>msg).msgRegulacion.errorConsultaRiesgoConsultable
        });*/
        }
      );
    }
  }

  redireccionarOpcion() {
    this.agregarParametrosRedireccion();
    if (
      this.redireccionService.optionMenuNotificaAYV(
        this.menuItem.redireccionMenu.opcionVenta
      )
    ) {
      this.dialogRef.close();
      this.dialogService.open(
        AsesoriaYVentaClienteDialogComponent,
        this.menuItem.redireccionMenu
      );
    } else if (
      this.redireccionService.optionMenuRegistraCliente(
        this.menuItem.redireccionMenu.opcionVenta
      )
    ) {
      this.route
        .navigateByUrl('/RefrshComponent', { skipLocationChange: true })
        .then(() => {
          this.agregarParametrosRedireccion();
          this.route.navigate(['Clientes']);
        });
    } else if (
      this.redireccionService.optionMenuRedireccionGWT(
        this.menuItem.redireccionMenu.opcionVenta
      )
    ) {
      this.redireccionService.redireccionProductoGWT(
        this.tipodocumentoSeleccionado.id.toString(),
        this.documento.toString()
      );
    } else if (
      this.redireccionService.optionMenuRedireccionAYVDirecta(
        this.menuItem.redireccionMenu.opcionVenta
      )
    ) {
      this.redireccionService.redireccionAYV(
        this.tipodocumentoSeleccionado.id.toString(),
        this.documento.toString()
      );
    }
  }

  agregarParametrosRedireccion() {
    this.redireccionService.setRedireccionMenu(this.menuItem.redireccionMenu);
    const filtroBusqueda: FiltroBuscarCliente = new FiltroBuscarCliente(
      new FiltroCliente(this.tipodocumentoSeleccionado.id, this.documento + ''),
      this.agenteService.getFiltroAgente()
    );
    this.clienteService.setfiltroBuscarCliente(filtroBusqueda);
    this.menuItem.redireccionMenu.filtroBuscarCliente = filtroBusqueda;
  }

  clickAceptarSubmit() {
    this.btnAceptar._elementRef.nativeElement.click();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cliente/dialogs/consulta-cliente-dialog/consulta-cliente-dialog.component.ts